export default {
  "HitPaw Online Audio Extractor": "HitPaw 온라인 오디오 추출기",
  "Extract sound from videos with ease.": "비디오에서  소리를 추출할 수 있습니다.",
  "Select Audio Format": "오디오 형식 선택하기",
  "Extract Audio": "오디오 추출하기",
  "Extracting Audio": "오디오 추출중입니다.",
  "Extracted Successfully": "성공적으로 압축했습니다.",
  "Extract New": "새로 추출하기",
  "Extraction Failed": "추출에 실패했습니다.",
  "Format": "형식",
};
